import OrgsIndexingGrid from './orgs-indexing-grid';

export default function OrgsIndexingPage() {
  return <OrgsIndexingGrid />;
}
